import React from 'react';
import { Alert } from 'react-bootstrap';
import * as PropTypes from 'prop-types';

import './Error.sass';

export const ErrorNotFound = ({ title, message }) => (
  <div className="error-page">
    <div className="jumbotron">
      <i className="error-icon fa fa-4x fa-exclamation-circle" />
      <h1>{title}</h1>
      <p>{message}</p>
    </div>
  </div>
);
ErrorNotFound.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
};
ErrorNotFound.defaultProps = {
  title: 'Page Not Found',
  message: 'Please use the navigation menu to get back on track',
};

export const ErrorBox = ({ title, error, children }) => (
  <Alert variant="danger">
    <h3>{title}</h3>
    {children}
    <hr />
    <p>
      <small className="text-muted">Error details: {error.message}</small>
    </p>
  </Alert>
);
ErrorBox.propTypes = {
  title: PropTypes.string,
  error: PropTypes.object,
};
ErrorBox.defaultProps = {
  title: 'Error',
};
